<template>
  <div class="q_mar_t15px q_pad_lr15px q_mar_b100px">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <van-image width="100%" fit="cover" :src="convertImg(activity.banner)"/>
      </van-swipe-item>
    </van-swipe>
    <div class="q_text_l q_bold q_mar_t15px q_mar_b20px">{{ activity.name }}</div>
    <div class="q_vertical_left q_acti q_mar_b10px" style="width: 100%;">
      <span class="q_text_m q_color_gray q_mar_l10px">{{ activity.description }}</span>
    </div>
    <div class="q_vertical_left q_acti q_mar_b10px" style="width: 100%;">
      <img src="@/assets/image/name.png"/>
      <span class="q_text_m q_color_gray q_mar_l10px">{{ activity.associationName }}</span>
    </div>
    <!--    <div class="q_vertical_left q_acti q_mar_b10px" style="width: 100%;">-->
    <!--      <img src="@/assets/image/applyTime.png"/>-->
    <!--      <span class="q_text_m q_color_gray q_mar_l10px">报名时间 {{-->
    <!--          parseTime(activity.startTime)-->
    <!--        }} 至 {{ parseTime(activity.endTime) }}</span>-->
    <!--    </div>-->
    <div class="q_vertical_left q_acti q_mar_b10px" style="width: 100%;">
      <img src="@/assets/image/time.png"/>
      <span class="q_text_m q_color_gray q_mar_l10px">活动时间 {{
          parseTime(activity.activityStartTime)
        }} 至 {{ parseTime(activity.activityEndTime) }}</span>
    </div>
    <div class="q_vertical_left q_acti q_mar_b10px" style="width: 100%;" v-if="activity.type=='1'">
      <img src="@/assets/image/time.png"/>
      <span class="q_text_m q_color_gray q_mar_l10px">签到时间 {{
          parseTime(activity.signStartTime)
        }} 至 {{ parseTime(activity.signEndTime) }}</span>
    </div>
    <!--    <div class="q_vertical_left q_acti q_mar_b10px" style="width: 100%;">-->
    <!--      <img src="../../assets/image/time.png" />-->
    <!--      <span class="q_text_m q_color_gray q_mar_l10px">{{activity.endTime}}</span>-->
    <!--    </div>-->
    <div class="q_vertical_left q_acti q_mar_b10px" style="width: 100%;">
      <img src="@/assets/image/address.png"/>
      <span class="q_text_m q_color_gray q_mar_l10px">活动地点 {{ activity.address }}</span>
    </div>
    <div class="q_vertical_left q_acti q_mar_b10px" style="width: 100%;" v-if="activity.type=='1'">
      <img src="@/assets/image/address.png"/>
      <span class="q_text_m q_color_gray q_mar_l10px">打卡距离 半径{{ activity.signScope }}米内</span>
    </div>
    <div class="q_vertical_left q_acti q_mar_b10px" style="width: 100%;">
      <img src="@/assets/image/num.png"/>
      <span class="q_text_m q_color_gray q_mar_l10px">已有 {{ activity.applyNumber == null ? '0' : activity.applyNumber }} 人成功报名</span>
    </div>
    <div class="q_vertical_left q_acti q_mar_b10px" style="width: 100%;">
      <img src="@/assets/image/int.png"/>
      <span class="q_text_m q_color_gray q_mar_l10px">成功参加可获得{{ activity.integral }}积分</span>
    </div>


    <div class="q_text_l q_bold q_mar_t20px q_bor_top q_pad_tb20px" v-if="activity.type=='1'">打卡范围</div>
    <div class="q_artdea" v-if="!loading&&activity.type=='1'&&currentLocation">
      <!--百度地图-->
      <baidu-map class="bm-view"
                 :center="{lng: parseFloat(activity.signLongitude), lat:  parseFloat(activity.signLatitude)}"
                 :zoom="15"
                 :scroll-wheel-zoom="true">
        <!--点标记-->
        <bm-marker :position="{lng: parseFloat(activity.signLongitude), lat: parseFloat(activity.signLatitude)}"
                   animation="BMAP_ANIMATION_BOUNCE">
          <bm-label content="打卡中心点" :labelStyle="{color: 'red', fontSize : '14px'}"
                    :offset="{width: -15, height: 10}"/>

        </bm-marker>


        <!--我的位置-->
        <bm-marker :position="{lng: parseFloat(currentLocation.longitude), lat: parseFloat(currentLocation.latitude)}"
                   animation="BMAP_ANIMATION_BOUNCE">
          <bm-label content="我的位置" :labelStyle="{color: 'red', fontSize : '14px'}"
                    :icon="{url: 'http://developer.baidu.com/map/jsdemo/img/fox.gif', size: {width: 300, height: 157}}"
                    :offset="{width: -15, height: 10}"/>
        </bm-marker>

        <!--获取当前定位-->
        <!--        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>-->
        <!--打卡范围-->
        <bm-circle :center="circlePath.center" :radius="circlePath.radius" stroke-color="blue" :stroke-opacity="0.5"
                   :stroke-weight="2" :editing="true"></bm-circle>
        <!--缩放-->
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
      </baidu-map>
    </div>


    <div class="q_text_l q_bold q_mar_t20px q_bor_top q_pad_tb20px">活动详情</div>
    <div class="q_artdea">
      <!--			<p>活动时间：4月18日 上午8点-下午5点</p>-->
      <!--			<p>活动地点：山东省烟台市招远市</p>-->
      <!--			<p>诚邀嘉宾：所有有意向的志愿者朋友</p>-->
      <!--			<p>参加路线：交通自理 建议绿色出行 地铁10号线 纪家庙地铁站 B东北口出</p>-->
      <!--			<p>（提供中午餐食）</p>-->
      <!--			<p>早7点30开始签到入场</p>-->
      <!--			<p><img src="../../assets/image/act.png" /></p>-->
      <div class="ql-editor" v-html="activity.details"></div>
    </div>
    <van-goods-action v-if="!loading">
      <!-- 已加入该协会 -->
      <van-goods-action-button type="danger" color="#FF5733" text="立即报名" @click="showPopup"
                               v-if="userDept&&userDept.state=='1'&&(userActivity==undefined||userActivity.state=='2')
                                    &&activity.activityEndTime>now"
                               :loading="buttonLoading"/>
      <!-- 未加入该协会 -->
      <van-goods-action-button type="danger" color="#FF5733" text="加入中队" @click="showPopup"
                               v-if="(!userDept||userDept.state=='2')&&activity.activityEndTime>now"
                               :loading="buttonLoading"/>

      <!-- 协会审核 -->
      <van-goods-action-button type="danger" color="#FF5733" text="入队申请正在审核" @click="showPopup" :disabled="true"
                               v-if="(userDept&&userDept.state=='0')&&activity.activityEndTime>now"
                               :loading="buttonLoading"/>

      <!--待审核-->
      <van-goods-action-button type="danger" color="#FF5733" text="报名申请正在审核" :disabled="true"
                               v-if="userDept&&userDept.state=='1'&&userActivity&&userActivity.state=='0'&&activity.activityEndTime>now"/>

      <!--可以签到-->
      <van-goods-action-button type="danger" color="#FF5733" text="签到打卡" @click="sign"
                               v-if="userDept&&userDept.state=='1'&&userActivity&&userActivity.state=='1'
                               &&activity.activityStartTime<now&&activity.activityEndTime>now&&activity.type=='1'
                               && userActivity.signTime==null
                               && currentLocation"
                               :loading="buttonLoading"/>
      <!--可以签退-->
      <van-goods-action-button type="danger" color="#FF5733" text="签退打卡" @click="signOut"
                               v-if="userDept&&userDept.state=='1'&&userActivity&&userActivity.state=='1'
                               &&activity.activityStartTime<now&&activity.activityEndTime>now&&activity.type=='1'
                                && userActivity.signTime!=null
                                && currentLocation"
                               :loading="buttonLoading"/>


      <!--位置获取失败-->
      <van-goods-action-button type="danger" color="#FF5733" text="位置获取失败，请刷新页面" :disabled="true"
                               v-if="!currentLocation&&activity.activityEndTime>now&&activity.type=='1'"/>

      <!--活动结束-->
      <van-goods-action-button type="danger" color="#FF5733" text="活动结束" :disabled="true"
                               v-if="activity.activityEndTime<now"/>


      <!--招募活动-->
      <van-goods-action-button type="danger" color="#FF5733" text="已参与活动" @click="sign" :disabled="true"
                               v-if="userDept&&userDept.state=='1'&&userActivity&&userActivity.state=='1'
                               &&activity.activityStartTime<now&&activity.activityEndTime>now&&activity.type=='2'
                              "
                               :loading="buttonLoading"/>


    </van-goods-action>
    <van-popup v-model="show" style="width: 60%;">
      <div class="q_center">
        <p class="q_text_m q_bold q_pad_15px">基础资料是否已确认无误？</p>
        <p class="q_text_s q_color_gray q_bor_bottom q_pad_b20px" @click="goToBasicdata()">去看看</p>
        <div>
          <span class="q_pad_tb15px q_inlineblock" style="width: 50%;" @click="show=false">取 消</span>
          <span class="q_pad_tb15px q_inlineblock q_color_default" style="width: 50%;"
                @click="joinAndApply()">确 认</span>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showMember" style="width: 60%;">
      <div class="q_center">
        <p class="q_text_m q_bold q_pad_15px">中队队费未缴费/已到期,请缴纳会费后报名</p>
        <!--        <p class="q_text_s q_color_gray q_bor_bottom q_pad_b20px" @click="goToMember()">去缴费</p>-->
        <div>
          <span class="q_pad_tb15px q_inlineblock" style="width: 50%;" @click="showMember=false">取 消</span>
          <span class="q_pad_tb15px q_inlineblock q_color_default" style="width: 50%;"
                @click="goToMember()">去缴费</span>
        </div>
      </div>
    </van-popup>


  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {listActivityById} from "@/api/activity";
import {addUserDept, getUserDeptByUserIdAndDeptId} from "@/api/userDept";
import {
  addUserActivity,
  getUserActivityByUserIdAndActivityId,
  userActivitySign,
  userActivitySignOut
} from "@/api/userActivity";
import {getLoginUser} from "@/api/login";
import {parseTime, wxCloseShare} from "@/utils/jiutang";
import {getJsapiSignature} from "@/api/wechat";
import gcoord from 'gcoord';

var wx = require('weixin-js-sdk');


export default {
  name: 'Activdea',
  props: {
    msg: String
  },
  data() {
    return {
      loading: true,
      currentLocation: undefined,
      circlePath: {
        center: {
          lng: 116.404,
          lat: 39.915
        },
        radius: 500
      },
      activity: {},
      activityId: '',
      show: false,
      showMember: false,
      buttonLoading: false,
      userDept: undefined,
      userActivity: undefined,
      user: undefined,
      now: Date.parse(new Date()) / 1000
    }
  },
  created() {
    wxCloseShare()
    this.activityId = this.$route.query.id;
    this.$modal.loading()
    this.loading = true
    getLoginUser().then(res => {
      this.user = res.data
    }).then(() => {
      this.init()
    }).finally(() => {
      this.loading = false
      this.$modal.closeLoading()
    })
  },
  methods: {
    /**
     * 获取位置信息
     */
    getLocation() {
      let url = window.location.href
      getJsapiSignature(url).then(res => {
        let self = this
        let wxConfig = res.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: wxConfig.appId, // 必填，公众号的唯一标识
          timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
          nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
          signature: wxConfig.signature,// 必填，签名
          jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表
        })
        wx.ready(function () {
          // wx.checkJsApi({
          //   jsApiList: ['getLocation'],
          //   success: function (res) {
          //     if (!res.checkResult.getLocation) {
          //       self.$modal.closeLoading()
          //       alert('暂不支持获取地理位置接口，请升级微信版本！');
          //       return;
          //     }
          //   }
          // })
          wx.getLocation({
            type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              console.log(res)
              // 获取位置成功
              var result = gcoord.transform(
                  [res.latitude, res.longitude],    // 经纬度坐标
                  gcoord.GCJ02,               // 当前坐标系
                  gcoord.BD09                 // 目标坐标系
              );
              self.currentLocation = {'latitude': result[0], 'longitude': result[1]}
            }, cancel: function (res) {
              self.$modal.closeLoading()
              alert('用户拒绝授权位置信息！');
            }
          })
        });
        wx.error(function (res) {
          self.$modal.closeLoading()
        });
      })
    },
    /**
     * 初始化
     */
    init() {
      this.loading = true
      this.$modal.loading()
      //获取活动详情信息
      listActivityById(this.activityId).then(res => {
        this.activity = res.data
        // 转换时间戳
        this.activity.activityStartTime = Date.parse(new Date(res.data.activityStartTime)) / 1000
        this.activity.activityEndTime = Date.parse(new Date(res.data.activityEndTime)) / 1000


        this.circlePath = {
          center: {
            lng: parseFloat(res.data.signLongitude),
            lat: parseFloat(res.data.signLatitude)
          },
          radius: res.data.signScope
        }
      }).then(() => {
        //查询协会与用户关系
        return getUserDeptByUserIdAndDeptId(this.activity.deptId)
      }).then(res => {
        if (res.data) {
          this.userDept = res.data
        }
        //查询活动与用户关系
        return getUserActivityByUserIdAndActivityId(this.activity.id)
      }).then(res => {
        if (res.data) {
          this.userActivity = res.data
        }
      }).then(() => {
        let url = window.location.href
        // 获取当前位置
        return getJsapiSignature(url)
      }).then(res => {
        let self = this
        let wxConfig = res.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: wxConfig.appId, // 必填，公众号的唯一标识
          timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
          nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
          signature: wxConfig.signature,// 必填，签名
          jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表
        })
        wx.ready(function () {
          // wx.checkJsApi({
          //   jsApiList: ['getLocation'],
          //   success: function (res) {
          //     if (!res.checkResult.getLocation) {
          //       self.$modal.closeLoading()
          //       alert('暂不支持获取地理位置接口，请升级微信版本！');
          //       return;
          //     }
          //   }
          // })
          wx.getLocation({
            type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              console.log(res)
              // 获取位置成功
              var result = gcoord.transform(
                  [res.latitude, res.longitude],    // 经纬度坐标
                  gcoord.GCJ02,               // 当前坐标系
                  gcoord.BD09                 // 目标坐标系
              );
              self.currentLocation = {'latitude': result[0], 'longitude': result[1]}
            }, cancel: function (res) {
              self.$modal.closeLoading()
              alert('用户拒绝授权位置信息！');
            }
          })
        });
        wx.error(function (res) {
          self.$modal.closeLoading()
        });
      }).finally(() => {
        console.log("[       " + this.currentLocation + "     ]")
        this.loading = false
        this.$modal.closeLoading()
      })
    },
    /**
     * 是否过期
     */
    isExpired(beginDate, endTime) {
      let curDate = new Date()
      beginDate = new Date(beginDate)
      endTime = new Date(endTime)
      if (curDate > beginDate && curDate < endTime) {
        return true
      } else {
        return false
      }
    },
    /**
     * 加入协会并报名
     */
    joinAndApply() {
      this.show = false
      this.buttonLoading = true
      this.$modal.loading("正在提交申请")

      //没有入会
      if (this.userDept == undefined || this.userDept.state == '0' || this.userDept.state == '2') {
        let data = {'userId': this.user.id, 'deptId': this.activity.deptId}
        //提交协会申请
        addUserDept(data).then(res => {
          // //提交报名申请
          // let applyData = {'userId': this.user.id, 'activityId': this.activity.id}
          // addUserActivity(applyData).then(res => {
          //   this.$modal.success("提交成功")
          //   setTimeout(() => {
          //     this.buttonLoading = false
          //     this.$modal.closeLoading()
          //     this.$router.push({
          //       path: '/mine/Mysign'
          //     });
          //   }, 1500);
          // }).catch(() => {
          //   this.buttonLoading = false
          //   this.$modal.closeLoading()
          // })
          this.buttonLoading = false
          this.$modal.closeLoading()
        }).catch(() => {
          this.buttonLoading = false
          this.$modal.closeLoading()
        }).finally(() => {
          this.buttonLoading = false
          this.$modal.closeLoading()
          this.init()
        })
      }
      //已经入会
      if (this.userDept != undefined && this.userDept.state == '1') {
        //提交报名申请
        let applyData = {'userId': this.user.id, 'activityId': this.activity.id}
        addUserActivity(applyData).then(res => {
          this.$modal.success("提交成功")
          this.init()
        }).catch((err) => {
          if (err == 'Error: 协会会费未缴费/已到期，请缴纳队费后报名') {
            this.showMember = true
          }
          this.buttonLoading = false
          this.$modal.closeLoading()
        })
      }


    },
    showPopup() {
      if (this.user.baseAudit == null) {
        return this.$modal.alert("请先完善基本信息");
      }
      if (this.user.baseAudit.auditState == '1') {
        this.show = true;
      } else {
        return this.$modal.alert("已完善信息，请耐心等待审核");
      }
    },
    goToBasicdata() {
      this.$router.push({
        path: '/mine/Basicd'
      });
    },
    goToMember() {
      this.$router.push({
        path: '/mine/Member', query: {id: this.activity.deptId}
      });
    },
    formatDate(date) {
      return new Date(date)
    },
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d} {h}:{i}')
    },
    /**
     * 签到打开
     */
    sign() {
      this.getLocation()
      this.$modal.loading('正在签到')
      let activityId = this.activityId

      console.log(this.currentLocation)
      // 获取位置成功，开始请求打卡
      let data = {
        'latitude': this.currentLocation.latitude,
        'longitude': this.currentLocation.longitude,
        'activityId': activityId
      }
      userActivitySign(data).then(res => {
        this.$modal.success('打卡成功')
        setTimeout(() => {
          this.init()
        }, 1000);
      })
    },
    /**
     * 签退打卡
     */
    signOut() {
      this.getLocation()
      this.$modal.loading('正在签退')
      let activityId = this.activityId
      // 获取位置成功，开始请求打卡
      let data = {
        'latitude': this.currentLocation.latitude,
        'longitude': this.currentLocation.longitude,
        'activityId': activityId
      }
      userActivitySignOut(data).then(res => {
        this.$modal.success('打卡成功')
        setTimeout(() => {
          this.init()
        }, 1000);
      })
    }
  },
}
</script>
<style scoped="scoped">
>>> .van-swipe {
  font-size: 0;
  border-radius: 5px;
}

.van-swipe .van-image {
  height: 194px;
}

.q_acti img {
  height: 14px;
}

.van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}

.van-popup {
  border-radius: 6px;
}

.bm-view {
  width: 100%;
  height: 300px;
}
</style>
